import './Header.css'

export default function Header() {
	return (
		<header className="header">
			<div className="container">
				<h1 className="header-title">Prompt Generator</h1>
				<span className="header-subtitle">Easy bash prompt generator</span>
			</div>
		</header>
	)
}
